(function(){
  'use strict';
  var $=function(s,c){return (c||document).querySelector(s)};
  var $$=function(s,c){return Array.prototype.slice.call((c||document).querySelectorAll(s))};
  function money(cents){
    /* show the visitor's market currency (GBP, EUR, AUD...) rather than the shop's USD format */
    var cur=(window.Shopify&&Shopify.currency&&Shopify.currency.active)||'USD';
    var MARKET_FMT={GBP:'\u00a3{{amount}}',EUR:'\u20ac{{amount_with_comma_separator}}',AUD:'${{amount}}',CAD:'${{amount}}'};
    var fmt=(cur!=='USD'&&MARKET_FMT[cur])||(window.MO&&window.MO.moneyFormat)||'${{amount}}';
    var v=(cents/100).toFixed(2);
    var parts=v.split('.');
    var withComma=parts[0].replace(/\B(?=(\d{3})+(?!\d))/g,',');
    return fmt.replace(/\{\{\s*amount\s*\}\}/,withComma+'.'+parts[1])
              .replace(/\{\{\s*amount_no_decimals\s*\}\}/,withComma)
              .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/,parts[0].replace(/\B(?=(\d{3})+(?!\d))/g,'.')+','+parts[1])
              .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/,parts[0].replace(/\B(?=(\d{3})+(?!\d))/g,'.'))
              .replace(/<[^>]+>/g,'');
  }

  window.moMoney=money;

  /* newsletter signups: Shopify protects customer forms with invisible hCaptcha, which only runs on a real
     submit event. A fetch() POST gets a 403 "challenge", so submit the real form into a hidden iframe. */
  window.moSubscribe=function(form,email,done){
    try{
      if(!form)return done&&done(false);
      var input=form.querySelector('input[type=email]');if(input)input.value=email;
      var frame=document.querySelector('iframe[name="mo_sub_frame"]');
      if(!frame){frame=document.createElement('iframe');frame.name='mo_sub_frame';frame.title='Newsletter signup';frame.setAttribute('aria-hidden','true');frame.tabIndex=-1;
        frame.style.cssText='position:absolute;width:1px;height:1px;left:-9999px;top:0;border:0;opacity:0';document.body.appendChild(frame);}
      var finished=false,finish=function(ok){if(finished)return;finished=true;if(done)done(ok);};
      frame.onload=function(){var ok=false;try{ok=!/challenge/.test(frame.contentWindow.location.href);}catch(e){ok=true;}finish(ok);};
      setTimeout(function(){finish(null);},8000);
      form.target='mo_sub_frame';
      var send=function(){
        if(form.requestSubmit)form.requestSubmit();
        else if(form.dispatchEvent(new Event('submit',{cancelable:true,bubbles:true})))form.submit();
      };
      /* the form must be bound to hCaptcha first, otherwise Shopify cancels the submit */
      if(form.dataset.hcaptchaBound||form.dataset.recaptchaBound){send();}
      else{var sent=false,go=function(){if(!sent){sent=true;send();}};window.moProtect(form,go);setTimeout(go,6000);}
    }catch(e){if(done)done(false);}
  };
  /* bind a hidden signup form to Shopify's hCaptcha ahead of time (call when a popup opens) */
  window.moProtect=function(form,cb){
    try{
      if(!form)return;
      if(form.dataset.hcaptchaBound||form.dataset.recaptchaBound){if(cb)cb();return;}
      if(window.Shopify&&Shopify.captcha&&Shopify.captcha.protect){Shopify.captcha.protect(form,function(){if(cb)cb();});}
      else if(cb)cb();
    }catch(e){if(cb)cb();}
  };

  /* countdown (evergreen, resets every N hours per visitor) */
  $$('[data-countdown]').forEach(function(el){
    var bar=el.closest('.announcement');
    var hours=parseInt(bar&&bar.getAttribute('data-countdown-hours')||'24',10);
    var key='mo_cd_end';
    var end=parseInt(localStorage.getItem(key)||'0',10);
    var now=Date.now();
    if(!end||end<now){end=now+hours*3600*1000;try{localStorage.setItem(key,String(end));}catch(e){}}
    function pad(n){return (n<10?'0':'')+n}
    function tick(){
      var d=Math.max(0,end-Date.now());
      var h=Math.floor(d/3600000),m=Math.floor(d%3600000/60000),s=Math.floor(d%60000/1000);
      el.querySelector('[data-h]').textContent=pad(h);
      el.querySelector('[data-m]').textContent=pad(m);
      el.querySelector('[data-s]').textContent=pad(s);
      if(d<=0){end=Date.now()+hours*3600*1000;try{localStorage.setItem(key,String(end));}catch(e){}}
    }
    tick();setInterval(tick,1000);
  });

  /* mobile nav */
  var mnav=$('[data-mobile-nav]');
  $$('[data-open-mobile-nav]').forEach(function(b){b.addEventListener('click',function(){mnav.classList.add('is-open')})});
  $$('[data-close-mobile-nav]').forEach(function(b){b.addEventListener('click',function(){mnav.classList.remove('is-open')})});

  /* cart drawer */
  var drawer=$('[data-cart-drawer]');
  function mountExpress(){var t=document.querySelector('[data-express-tpl]'),slot=document.querySelector('[data-express-slot]');if(!t||!slot)return;slot.appendChild(t.content.cloneNode(true));t.parentNode.removeChild(t);}
  (function(){var done=false,go=function(){if(done)return;done=true;['pointerdown','keydown','touchstart'].forEach(function(e){removeEventListener(e,go,true)});(window.requestIdleCallback||setTimeout)(mountExpress,{timeout:1500});};['pointerdown','keydown','touchstart'].forEach(function(e){addEventListener(e,go,{capture:true,passive:true})});})();
  function openCart(){if(!drawer)return;mountExpress();drawer.classList.add('is-open');drawer.setAttribute('aria-hidden','false');document.body.style.overflow='hidden';refreshCart();}
  function closeCart(){if(!drawer)return;drawer.classList.remove('is-open');drawer.setAttribute('aria-hidden','true');document.body.style.overflow='';}
  $$('[data-open-cart]').forEach(function(b){b.addEventListener('click',openCart)});
  $$('[data-close-cart]').forEach(function(b){b.addEventListener('click',closeCart)});
  document.addEventListener('keydown',function(e){if(e.key==='Escape'){closeCart();closeQuiz();}});

  function renderCart(cart){
    $$('[data-cart-count]').forEach(function(el){el.textContent=cart.item_count});
    var body=$('[data-cart-body]'),foot=$('[data-cart-foot]');
    if(!body)return;
    if(!cart.items.length){body.innerHTML='<div class="drawer__empty">Your bag is empty.</div>';foot.hidden=true;if(window.moReserveStart)window.moReserveStart(0);renderExtras(cart);return;}
    body.innerHTML=cart.items.map(function(it,i){
      var props=Object.keys(it.properties||{}).filter(function(k){return it.properties[k]}).map(function(k){return '<div class="line__props">'+k+': '+it.properties[k]+'</div>'}).join('');
      return '<div class="line" data-line="'+(i+1)+'">'
        +'<div class="line__img">'+(it.image?'<img src="'+it.image.replace(/(\.[a-z]+)(\?|$)/,'_200x$1$2')+'" alt="">':'')+'</div>'
        +'<div><div class="line__title">'+it.product_title+'</div>'+(it.variant_title&&it.variant_title!=='Default Title'?'<div class="line__variant">'+it.variant_title+'</div>':'')+props
        +'<div class="qty"><button type="button" data-qty="-1" aria-label="Decrease">−</button><span>'+it.quantity+'</span><button type="button" data-qty="1" aria-label="Increase">+</button></div>'
        +'<button type="button" class="line__remove" data-remove>Remove</button></div>'
        +'<div class="line__price">'+money(it.final_line_price)+'</div></div>'
        +freeRow(it);
    }).join('');
    $('[data-cart-total]').textContent=money(cart.total_price);
    foot.hidden=false;
    if(window.moReserveStart) window.moReserveStart(cart.item_count);
    renderExtras(cart);
    $$('[data-qty]',body).forEach(function(b){b.addEventListener('click',function(){
      var line=b.closest('[data-line]');var idx=parseInt(line.getAttribute('data-line'),10);
      var q=parseInt(line.querySelector('.qty span').textContent,10)+parseInt(b.getAttribute('data-qty'),10);
      changeLine(idx,Math.max(0,q));
    })});
    $$('[data-remove]',body).forEach(function(b){b.addEventListener('click',function(){changeLine(parseInt(b.closest('[data-line]').getAttribute('data-line'),10),0)})});
  }
  /* basket extras: one-tap upgrade to the next bundle + what they save */
  var productCache={};
  function productJson(handle){
    if(!productCache[handle]) productCache[handle]=fetch('/products/'+handle+'.js',{credentials:'same-origin'}).then(function(r){return r.json()});
    return productCache[handle];
  }
  function renderExtras(cart){
    var up=$('[data-cart-upsell]'),sv=$('[data-cart-savings]');
    if(up){up.hidden=true;up.innerHTML='';}
    if(sv){sv.hidden=true;sv.textContent='';}
    if(!up&&!sv)return;
    if(!cart.items.length)return;
    var handles=cart.items.map(function(i){return i.handle}).filter(function(h,i,a){return h&&a.indexOf(h)===i});
    Promise.all(handles.map(productJson)).then(function(ps){
      var byId={};ps.forEach(function(p){(p.variants||[]).forEach(function(v,i){byId[v.id]={v:v,p:p,i:i}})});
      var saved=0;
      cart.items.forEach(function(it){var m=byId[it.variant_id];if(m&&m.v.compare_at_price>m.v.price)saved+=(m.v.compare_at_price-m.v.price)*it.quantity;});
      if(sv&&saved>0){sv.textContent='You save '+money(saved)+' on this order';sv.hidden=false;}
      if(!up)return;
      try{ if(sessionStorage.getItem('mo_up_no')) return; }catch(e){}
      /* one-tap upgrade to the biggest bundle (owner-approved 2026-09-26): only for a single line of 1 */
      var it=cart.items[0],m=byId[it.variant_id];if(!m||cart.items.length!==1||it.quantity!==1)return;
      var tubes=function(v){var x=/buy\s+(\d+)(?:\s+get\s+(\d+)\s+free)?/i.exec(v.title||'');return x?(+x[1])+(x[2]?+x[2]:0):1;};
      var next=m.p.variants.filter(function(v){return v.available;}).reduce(function(a,v){return tubes(v)>tubes(a)?v:a;},m.v);
      var nt=tubes(next);if(nt<=tubes(m.v))return;
      var extra=Math.max(0,next.price-m.v.price);
      up.innerHTML='<div class="upsell__txt"><strong>Make it '+nt+' for just '+money(extra)+' more</strong>'
        +'<span>'+money(Math.round(next.price/nt))+' a lipstick, still free shipping.</span>'
        +'<button type="button" class="upsell__no" data-upsell-no>No thanks</button></div>'
        +'<button type="button" class="upsell__btn" data-upsell-go>+'+money(extra)+'</button>';
      up.hidden=false;
      $('[data-upsell-no]',up).addEventListener('click',function(){try{sessionStorage.setItem('mo_up_no','1');}catch(e){} up.hidden=true;up.innerHTML='';});
      $('[data-upsell-go]',up).addEventListener('click',function(){
        var b=this;b.disabled=true;b.textContent='Adding…';
        fetch(window.MO.cartAddUrl+'.js',{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json','Accept':'application/json'},
          body:JSON.stringify({items:[{id:next.id,quantity:it.quantity,properties:it.properties||{}}]})})
          .then(function(r){return r.json()})
          .then(function(){return fetch(window.MO.cartChangeUrl+'.js',{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({id:it.key,quantity:0})})})
          .then(function(r){return r.json()})
          .then(function(c){
            try{if(window.moTrack)window.moTrack('AddToCart',{content_type:'product',content_ids:[next.id],content_name:it.product_title+' upgrade',num_items:it.quantity,value:Math.max(0,extra)/100,currency:c.currency||'USD'});}catch(e){}
            renderCart(c);
          }).catch(function(){b.disabled=false;refreshCart();});
      });
    }).catch(function(){});
  }
  /* bundles ("Buy 1 Get 1 Free"): show the free lipstick(s) as their own FREE row */
  function freeRow(it){
    var m=/buy\s+(\d+)\s+get\s+(\d+)\s+free/i.exec(it.variant_title||'');if(!m)return '';
    var paid=parseInt(m[1],10),free=parseInt(m[2],10)*it.quantity;
    var unit=(window.MO&&window.MO.singlePrice)||Math.round(it.price/paid);
    return '<div class="line line--free">'
      +'<div class="line__img">'+(it.image?'<img src="'+it.image.replace(/(\.[a-z]+)(\?|$)/,'_200x$1$2')+'" alt="">':'')+'</div>'
      +'<div><div class="line__title">'+it.product_title+'</div><div class="line__variant">'+(free>1?free+' lipsticks':'1 lipstick')+' free with your bundle</div></div>'
      +'<div class="line__price"><span class="line__free">Free</span><s>'+money(unit*free)+'</s></div></div>';
  }
  function refreshCart(){fetch(window.MO.cartJsonUrl,{credentials:'same-origin'}).then(function(r){return r.json()}).then(renderCart).catch(function(){});}
  function changeLine(line,qty){
    fetch(window.MO.cartChangeUrl+'.js',{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({line:line,quantity:qty})})
      .then(function(r){return r.json()}).then(renderCart);
  }
  function addToCart(fd,btn){
    var txt=btn?btn.querySelector('[data-atc-text]'):null;var old=txt?txt.textContent:'';
    if(btn){btn.disabled=true;if(txt)txt.textContent='Adding…';}
    return fetch(window.MO.cartAddUrl+'.js',{method:'POST',credentials:'same-origin',headers:{'Accept':'application/json'},body:fd})
      .then(function(r){return r.json()})
      .then(function(res){
        if(res.status&&res.status>=400){alert(res.description||res.message||'Could not add to cart');return;}
        try{ if(window.moTrack){ var its=res.items||[res];
          window.moTrack('AddToCart',{content_type:'product',
            content_ids: its.map(function(i){return i.variant_id||i.id;}),
            content_name: its[0] && its[0].product_title,
            num_items: its.reduce(function(a,i){return a+(i.quantity||1);},0),
            value: its.reduce(function(a,i){return a+((i.final_line_price!=null?i.final_line_price:(i.price||0)*(i.quantity||1)));},0)/100});
        } }catch(e){}
        openCart();
      }).catch(function(){}).then(function(){if(btn){btn.disabled=false;if(txt)txt.textContent=old;}});
  }

  /* product form */
  var form=$('[data-product-form]');
  if(form){
    var variantInput=$('[data-variant-input]',form);
    var offers=$$('[data-offer]',form);
    function selectOffer(el){
      offers.forEach(function(o){o.classList.toggle('is-selected',o===el)});
      var r=el.querySelector('input[type=radio]');if(r)r.checked=true;
      variantInput.value=el.getAttribute('data-variant-id');
      try{var u=new URL(location.href);u.searchParams.set('variant',variantInput.value);history.replaceState({},'',u);}catch(e){}
    }
    offers.forEach(function(o){o.addEventListener('click',function(e){e.preventDefault();if(o.querySelector('input').disabled)return;selectOffer(o);})});
    var pre=offers.filter(function(o){return o.classList.contains('is-selected')})[0]||offers[0];
    if(pre)selectOffer(pre);
    form.addEventListener('submit',function(e){e.preventDefault();addToCart(new FormData(form),$('[data-add-to-cart]',form));});
  }

  /* gallery */
  var gallery=$('[data-gallery]');
  if(gallery){
    var main=$('[data-main-image]',gallery);
    var thumbs=$$('.gallery__thumbs button',gallery);
    function showThumb(i){
      if(!thumbs.length)return;
      i=(i+thumbs.length)%thumbs.length;
      var b=thumbs[i];
      thumbs.forEach(function(x){x.classList.remove('is-active')});b.classList.add('is-active');
      var src=b.getAttribute('data-thumb'),set=b.getAttribute('data-thumb-srcset');if(main&&src){if(set)main.srcset=set;else main.removeAttribute('srcset');main.src=src;}
      var strip=b.parentNode;
      if(strip.scrollWidth>strip.clientWidth){strip.scrollTo({left:b.offsetLeft-strip.clientWidth/2+b.offsetWidth/2,behavior:'smooth'});}
    }
    function current(){for(var i=0;i<thumbs.length;i++){if(thumbs[i].classList.contains('is-active'))return i;}return 0;}
    thumbs.forEach(function(b,i){b.addEventListener('click',function(){showThumb(i)})});
    var gp=$('[data-gallery-prev]',gallery),gn=$('[data-gallery-next]',gallery);
    if(gp)gp.addEventListener('click',function(){showThumb(current()-1)});
    if(gn)gn.addEventListener('click',function(){showThumb(current()+1)});
    var gm=$('.gallery__main',gallery),sx=null,sy=null;
    if(gm){
      gm.addEventListener('touchstart',function(e){var t=e.touches[0];sx=t.clientX;sy=t.clientY;},{passive:true});
      gm.addEventListener('touchend',function(e){
        if(sx===null)return;var t=e.changedTouches[0],dx=t.clientX-sx,dy=t.clientY-sy;sx=null;
        if(Math.abs(dx)>40&&Math.abs(dx)>Math.abs(dy)*1.3){showThumb(current()+(dx<0?1:-1));}
      },{passive:true});
    }
  }

  /* carousels (testimonials, steps): dots + arrows, one card per view on phones */
  $$('[data-carousel]').forEach(function(c){
    var tr=$('[data-carousel-track]',c),dots=$('[data-carousel-dots]',c);
    if(!tr)return;
    var items=Array.prototype.slice.call(tr.children);
    if(dots){
      dots.innerHTML=items.map(function(_,i){return '<button type="button" aria-label="Go to slide '+(i+1)+'"'+(i===0?' class="is-active"':'')+'></button>'}).join('');
    }
    var db=dots?$$('button',dots):[];
    function center(i){var it=items[i];if(!it)return;tr.scrollTo({left:it.offsetLeft-(tr.clientWidth-it.offsetWidth)/2,behavior:'smooth'});}
    function active(){
      var mid=tr.scrollLeft+tr.clientWidth/2,best=0,bd=1e9;
      items.forEach(function(it,i){var d=Math.abs(it.offsetLeft+it.offsetWidth/2-mid);if(d<bd){bd=d;best=i;}});
      return best;
    }
    function paint(){var a=active();db.forEach(function(d,i){d.classList.toggle('is-active',i===a)});
      var p=$('[data-carousel-prev]',c),n=$('[data-carousel-next]',c);
      if(p)p.disabled=a===0; if(n)n.disabled=a===items.length-1;}
    db.forEach(function(d,i){d.addEventListener('click',function(){center(i)})});
    var cp=$('[data-carousel-prev]',c),cn=$('[data-carousel-next]',c);
    if(cp)cp.addEventListener('click',function(){center(Math.max(0,active()-1))});
    if(cn)cn.addEventListener('click',function(){center(Math.min(items.length-1,active()+1))});
    var raf=null;tr.addEventListener('scroll',function(){if(raf)return;raf=requestAnimationFrame(function(){raf=null;paint();});},{passive:true});
    window.addEventListener('resize',paint);paint();
  });

  /* header: tucks away while scrolling down on phones, returns on scroll up */
  (function(){
    var h=document.getElementById('shopify-section-header');if(!h)return;
    var last=window.scrollY,ticking=false;
    function upd(){
      ticking=false;var y=window.scrollY;
      var open=document.querySelector('[data-mobile-nav].is-open,[data-cart-drawer].is-open');
      if(window.innerWidth>900||open||y<140){h.classList.remove('is-tucked');}
      else if(y>last+6){h.classList.add('is-tucked');}
      else if(y<last-6){h.classList.remove('is-tucked');}
      if(Math.abs(y-last)>6)last=y;
    }
    window.addEventListener('scroll',function(){if(!ticking){ticking=true;requestAnimationFrame(upd);}},{passive:true});
  })();

  /* footer menus: collapsible on phones, always open on larger screens */
  (function(){
    var menus=$$('[data-footer-menu]');if(!menus.length)return;
    var mq=window.matchMedia('(min-width: 761px)');
    function sync(){menus.forEach(function(m){if(mq.matches)m.setAttribute('open','');else m.removeAttribute('open');});}
    sync();if(mq.addEventListener)mq.addEventListener('change',sync);
    menus.forEach(function(m){m.querySelector('summary').addEventListener('click',function(e){if(mq.matches)e.preventDefault();});});
  })();

  /* testimonials nav */
  var track=$('[data-testi-track]');
  if(track){
    var step=function(){return (track.firstElementChild?track.firstElementChild.getBoundingClientRect().width:300)+18};
    var p=$('[data-testi-prev]'),n=$('[data-testi-next]');
    if(p)p.addEventListener('click',function(){track.scrollBy({left:-step(),behavior:'smooth'})});
    if(n)n.addEventListener('click',function(){track.scrollBy({left:step(),behavior:'smooth'})});
  }

  /* reviews load more */
  var more=$('[data-reviews-more]');
  if(more){more.addEventListener('click',function(){
    var hidden=$$('[data-reviews] .review:not(.is-visible)');
    hidden.slice(0,6).forEach(function(r){r.classList.add('is-visible')});
    if(hidden.length<=6)more.parentNode.style.display='none';
  })}

  /* quiz */
  var qm=$('[data-quiz-modal]');
  var qdata=null;try{var qd=$('[data-quiz-data]');qdata=qd?JSON.parse(qd.textContent):null;}catch(e){}
  function closeQuiz(){if(qm){qm.classList.remove('is-open');qm.setAttribute('aria-hidden','true');document.body.style.overflow='';}}
  function openQuiz(){if(!qm||!qdata)return;qm.classList.add('is-open');qm.setAttribute('aria-hidden','false');document.body.style.overflow='hidden';renderQ(0);}
  function renderQ(i){
    var body=$('[data-quiz-body]',qm),bar=$('[data-quiz-progress]',qm);
    var qs=qdata.questions;
    if(i>=qs.length){
      bar.style.width='100%';
      body.innerHTML='<div class="quiz__result"><h3>'+qdata.result_title+'</h3><p>'+qdata.result_text+'</p><button type="button" class="btn btn--dark btn--full btn--lg" data-quiz-done>'+qdata.result_cta+'</button></div>';
      $('[data-quiz-done]',body).addEventListener('click',function(){closeQuiz();var o=$('[data-offers]');if(o)o.scrollIntoView({behavior:'smooth',block:'center'});});
      return;
    }
    bar.style.width=Math.round(i/qs.length*100)+'%';
    body.innerHTML='<div style="font-size:12px;letter-spacing:.16em;text-transform:uppercase;color:var(--c-muted)">Question '+(i+1)+' of '+qs.length+'</div><div class="quiz__q">'+qs[i].q+'</div><div class="quiz__opts">'+qs[i].opts.filter(Boolean).map(function(o){return '<button type="button">'+o+'</button>'}).join('')+'</div>';
    $$('.quiz__opts button',body).forEach(function(b){b.addEventListener('click',function(){renderQ(i+1)})});
  }
  $$('[data-open-quiz]').forEach(function(b){b.addEventListener('click',openQuiz)});
  $$('[data-close-quiz]').forEach(function(b){b.addEventListener('click',closeQuiz)});

  /* delivery estimate under Add to cart (matches the shipping policy windows) */
  (function(){
    var box=$('[data-eta]');if(!box)return;
    var cc=(box.getAttribute('data-country')||'US').toUpperCase();
    var EU='AT BE BG HR CY CZ DK EE FI FR DE GR HU IE IT LV LT LU MT NL PL PT RO SK SI ES SE GB CH NO IS'.split(' ');
    var win=cc==='US'?[7,10]:(EU.indexOf(cc)>-1?[5,8]:[10,16]);
    function addBiz(d,n){d=new Date(d);while(n>0){d.setDate(d.getDate()+1);var w=d.getDay();if(w!==0&&w!==6)n--;}return d;}
    var ship=addBiz(new Date(),1);
    var a=addBiz(ship,win[0]),b=addBiz(ship,win[1]);
    var f={month:'short',day:'numeric'};
    try{$('[data-eta-range]',box).textContent=a.toLocaleDateString('en-US',f)+' – '+b.toLocaleDateString('en-US',f);box.hidden=false;}catch(e){}
  })();

  /* known email (from the wheel or basket saver) is carried into checkout, so an abandoned checkout can be recovered */
  document.addEventListener('click',function(e){
    var a=e.target.closest?e.target.closest('a[data-checkout]'):null;if(!a)return;
    var em=null;try{em=localStorage.getItem('mo_lead_email');}catch(x){}
    if(em){e.preventDefault();location.href='/checkout?checkout%5Bemail%5D='+encodeURIComponent(em);}
  },true);
  (function(){
    var f=document.getElementById('CartPageForm');if(!f)return;
    f.addEventListener('submit',function(e){
      var sub=e.submitter;if(!sub||sub.name!=='checkout')return;
      var em=null;try{em=localStorage.getItem('mo_lead_email');}catch(x){}
      if(!em)return;
      e.preventDefault();
      fetch('/cart/update.js',{method:'POST',credentials:'same-origin',body:new FormData(f)}).then(function(){},function(){})
        .then(function(){location.href='/checkout?checkout%5Bemail%5D='+encodeURIComponent(em);});
    });
  })();

  /* fade-up */
  if('IntersectionObserver' in window){
    var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('in');io.unobserve(e.target);}})},{threshold:.12});
    $$('.fade-up').forEach(function(el){io.observe(el)});
  }else{$$('.fade-up').forEach(function(el){el.classList.add('in')})}

  /* basket reservation countdown in the cart drawer */
  (function(){
    var box=$('[data-reserve]');
    if(!box) return;
    var out=$('[data-reserve-time]',box), label=$('[data-reserve-label]',box);
    var MIN=parseInt(box.getAttribute('data-minutes'),10)||10;
    var DONE=box.getAttribute('data-done')||'Checkout now to keep this price';
    var BASE=label?label.textContent:'';
    var KEY='mo_basket_reserved_until', tick=null;
    function until(){ try{ return parseInt(sessionStorage.getItem(KEY),10)||0; }catch(e){ return 0; } }
    function paint(){
      var left=Math.floor((until()-Date.now())/1000);
      if(left<=0){
        box.classList.add('is-done');
        if(label) label.textContent=DONE;
        if(out) out.textContent='';
        if(tick){ clearInterval(tick); tick=null; }
        return;
      }
      box.classList.remove('is-done');
      if(label) label.textContent=BASE;
      var m=Math.floor(left/60), sec=left%60;
      if(out) out.textContent=m+':'+(sec<10?'0':'')+sec;
    }
    window.moReserveStart=function(count){
      if(!count){
        box.hidden=true;
        try{ sessionStorage.removeItem(KEY); }catch(e){}
        if(tick){ clearInterval(tick); tick=null; }
        return;
      }
      box.hidden=false;
      if(until()-Date.now()<=0){
        try{ sessionStorage.setItem(KEY,String(Date.now()+MIN*60*1000)); }catch(e){}
      }
      paint();
      if(!tick) tick=setInterval(paint,1000);
    };
  })();

})();

/* customer videos in the buy box: covers only; a tap opens the full-screen player (video downloads on tap, never before).
   Custom minimal controls: tap video = play/pause, scrubber (drag or tap, touch events on phones), time label, sound toggle, close. No native HUD. */
(function(){
  var items=document.querySelectorAll('[data-ugc]'), m=document.querySelector('[data-vmodal]');
  if(!items.length || !m) return;
  document.body.appendChild(m);
  var v=m.querySelector('video'), prog=m.querySelector('[data-vmodal-progress]'), knob=m.querySelector('[data-vmodal-knob]'),
      scrub=m.querySelector('[data-vmodal-scrub]'), track=scrub.querySelector('.vmodal__track'), tl=m.querySelector('[data-vmodal-time]');
  var dragging=false, resume=false;
  function fmt(t){ t=Math.max(0,Math.floor(t||0)); return Math.floor(t/60)+':'+('0'+(t%60)).slice(-2); }
  function dur(){ var d=v.duration; return (d && isFinite(d)) ? d : 0; }
  function paint(t){ var d=dur(), p=d ? Math.min(100,t/d*100) : 0; prog.style.width=p+'%'; knob.style.left=p+'%'; tl.textContent=d ? fmt(t)+' / '+fmt(d) : fmt(t); }
  function state(){ m.classList.toggle('is-paused',v.paused && !dragging); m.classList.toggle('is-muted',v.muted); }
  function open(it){
    var img=it.querySelector('img');
    v.poster=img ? (img.currentSrc||img.src) : '';
    v.src=it.getAttribute('data-src'); paint(0);
    m.hidden=false; document.body.classList.add('vmodal-open');
    v.muted=false; var pr=v.play();
    if(pr && pr.catch) pr.catch(function(){ v.muted=true; var p2=v.play(); if(p2 && p2.catch) p2.catch(function(){}); state(); });
    state();
  }
  function close(){ dragging=false; m.classList.remove('is-scrubbing'); v.pause(); v.removeAttribute('src'); v.load(); m.hidden=true; document.body.classList.remove('vmodal-open'); paint(0); }
  function seekTo(clientX){
    var d=dur(); if(!d) return;
    var r=track.getBoundingClientRect(), t=Math.max(0,Math.min(1,(clientX-r.left)/r.width))*d;
    paint(t); try{ v.currentTime=t; }catch(e){}
  }
  ['play','playing','pause','volumechange'].forEach(function(ev){ v.addEventListener(ev,state); });
  ['timeupdate','loadedmetadata','durationchange','seeked'].forEach(function(ev){ v.addEventListener(ev,function(){ if(!dragging) paint(v.currentTime); }); });
  items.forEach(function(it){ it.addEventListener('click',function(){ open(it); }); });
  m.querySelector('[data-vmodal-toggle]').addEventListener('click',function(){ if(v.paused){ var p=v.play(); if(p && p.catch) p.catch(function(){}); } else { v.pause(); } });
  m.querySelector('[data-vmodal-mute]').addEventListener('click',function(){ v.muted=!v.muted; if(!v.muted && v.paused){ v.play(); } });
  function startDrag(x){ dragging=true; resume=!v.paused; m.classList.add('is-scrubbing'); v.pause(); seekTo(x); }
  function moveDrag(x){ if(dragging) seekTo(x); }
  function endDrag(x){
    if(!dragging) return;
    if(x!=null) seekTo(x);
    dragging=false; m.classList.remove('is-scrubbing');
    if(resume){ var p=v.play(); if(p && p.catch) p.catch(function(){}); }
    state();
  }
  /* phones: native touch events (reliable on iOS Safari; preventDefault keeps the page from scrolling) */
  scrub.addEventListener('touchstart',function(e){ e.preventDefault(); e.stopPropagation(); startDrag(e.touches[0].clientX); },{passive:false});
  scrub.addEventListener('touchmove',function(e){ e.preventDefault(); moveDrag(e.touches[0].clientX); },{passive:false});
  scrub.addEventListener('touchend',function(e){ e.preventDefault(); var t=e.changedTouches && e.changedTouches[0]; endDrag(t ? t.clientX : null); },{passive:false});
  scrub.addEventListener('touchcancel',function(){ endDrag(null); });
  /* mouse / trackpad */
  scrub.addEventListener('pointerdown',function(e){ if(e.pointerType==='touch') return; e.preventDefault(); try{ scrub.setPointerCapture(e.pointerId); }catch(x){} startDrag(e.clientX); });
  scrub.addEventListener('pointermove',function(e){ if(e.pointerType!=='touch') moveDrag(e.clientX); });
  scrub.addEventListener('pointerup',function(e){ if(e.pointerType!=='touch') endDrag(e.clientX); });
  scrub.addEventListener('pointercancel',function(e){ if(e.pointerType!=='touch') endDrag(null); });
  scrub.addEventListener('click',function(e){ e.stopPropagation(); });
  m.querySelectorAll('[data-vmodal-close]').forEach(function(b){ b.addEventListener('click',close); });
  document.addEventListener('keydown',function(e){ if(e.key==='Escape' && !m.hidden) close(); });
})();
/* guarantee banner button: glide back up to the offers */
document.addEventListener('click',function(e){
  var a=e.target.closest ? e.target.closest('a[href="#buy"]') : null; if(!a) return;
  var t=document.getElementById('buy'); if(!t) return;
  e.preventDefault(); t.scrollIntoView({behavior:'smooth',block:'start'});
});
